const DATA = ['partner1', 'Indochine Counsel', 'MOA IP', 'Minwoo Group', 'partner5', 'partner6']

export default DATA
